import { forwardRef } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { Button, IconButton } from "@atoms"

import { ViewBarViewMenuButtonProps } from "./ViewBarViewMenuButton.types"

function ViewBarViewMenuButton(props: ViewBarViewMenuButtonProps, ref: React.Ref<HTMLButtonElement>) {
    const { onClick, isDisabled, isPressed, ...rest } = props

    const isDesktop = useIsDesktop()

    // Button and IconButton require onClick; as a Popover.Trigger child the real handler arrives from Radix.
    const handleClick = onClick ?? (() => {})

    if (isDesktop) {
        return (
            <Button
                {...rest}
                ref={ref}
                size="sm"
                variant="subtle"
                leftIcon={faIcon({ name: "sliders", style: "regular" })}
                onClick={handleClick}
                noDebounce={true}
                isDisabled={isDisabled}
                isPressed={isPressed}
            >
                View
            </Button>
        )
    } else {
        return (
            <IconButton
                {...rest}
                ref={ref}
                size="md"
                variant="subtle"
                icon={faIcon({ name: "sliders", style: "regular" })}
                onClick={handleClick}
                noDebounce={true}
                isDisabled={isDisabled}
                isPressed={isPressed}
                aria-label="View"
            />
        )
    }
}

export default forwardRef(ViewBarViewMenuButton)
